import React, { useState, useEffect } from 'react';

interface EditModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSave: (updatedData: any) => void;
	initialData: any;
}

const EditModal: React.FC<EditModalProps> = ({ isOpen, onClose, onSave, initialData }) => {
	const [editableData, setEditableData] = useState<any>(initialData ? { ...initialData } : {});
	const [errorMessage, setErrorMessage] = useState<string>('');
	useEffect(() => {
		if (initialData) {
			setEditableData({ ...initialData });
		} else {
			setEditableData({});
		}
		setErrorMessage('');
	}, [initialData]);

	const handleChange = (key: string, value: string) => {
		setEditableData((prev: any) => ({
			...prev,
			[key]: value,
		}));
	};
	if (!isOpen) return null;
	const requiredFields = ['suggested_response', 'remarks', 'review_status'];
	const allowedFields = [
		'question',
		'llm_response',
		'agent_response',
		'suggested_response',
		'remarks',
		'review_status',
	];

	const handleSaveClick = () => {
		const missingFields = requiredFields.filter(
			(field) => !editableData[field] || !editableData[field].toString().trim()
		);
		if (missingFields.length > 0) {
			setErrorMessage('Please fill out all required fields.');
			return;
		}
		setErrorMessage('');
		onSave(editableData);
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-75">
			<div className="bg-white p-6 rounded-lg max-w-3xl w-full relative">
				<button className="absolute top-3 right-3 text-3xl text-gray-500" onClick={onClose}>
					&times;
				</button>
				<h2 className="text-xl font-semibold mb-4">Human Feedback</h2>
				<hr className="my-2 border-gray-300" />
				<div className="overflow-y-auto max-h-96 space-y-4">
					{allowedFields.map((key) => {
						const value = editableData[key] || '';
						return (
							<div key={key} className="flex">
								<label className="w-1/4 font-medium text-gray-700 capitalize">
									{key.replace(/_/g, ' ')}:
									{requiredFields.includes(key) && <span className="text-red-600 ml-1">*</span>}
								</label>
								<div className="w-3/4">
									{key === 'suggested_response' || key === 'remarks' ? (
										<textarea
											value={value}
											onChange={(e) => handleChange(key, e.target.value)}
											className="text-gray-600 p-2 border border-gray-300 rounded-md w-full h-32"
										/>
									) : key === 'review_status' ? (
										<select
											value={value}
											onChange={(e) => handleChange(key, e.target.value)}
											className="text-gray-600 p-2 border border-gray-300 rounded-md w-full"
										>
											<option value="Not reviewed">Not reviewed</option>
											<option value="Reviewed">Reviewed</option>
											<option value="Invalid">Invalid</option>
										</select>
									) : (
										<p className="text-gray-600">{value}</p>
									)}
								</div>
							</div>
						);
					})}
				</div>
				{errorMessage && <div className="mt-2 text-red-600 text-sm">{errorMessage}</div>}
				<div className="mt-4 flex justify-end gap-4">
					<button className="bg-gray-600 text-white px-4 py-2 rounded-md" onClick={onClose}>
						Cancel
					</button>
					<button className="bg-blue-600 text-white px-4 py-2 rounded-md" onClick={handleSaveClick}>
						Save
					</button>
				</div>
			</div>
		</div>
	);
};

export default EditModal;
